var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "article-grid-component" }, [
    _c(
      "div",
      { staticClass: "item-collection-grid" },
      _vm._l(_vm.posts, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            ref: "gridItem",
            refInFor: true,
            staticClass: "item no-hover post",
            on: {
              mouseleave: function($event) {
                return _vm.removeHover(index)
              }
            }
          },
          [
            _c("div", {
              staticClass: "top-title",
              domProps: { innerHTML: _vm._s(_vm.getItemDate(item)) }
            }),
            _vm._v(" "),
            _c("h2", {
              staticClass: "title",
              domProps: { innerHTML: _vm._s(item.post_title) }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "description-short",
              domProps: {
                innerHTML: _vm._s(item.acf_fields.feature_settings.post_excerpt)
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "toggle-container hover-remove" }, [
              _c(
                "a",
                { staticClass: "link", attrs: { href: item.permalink } },
                [
                  _c("i", {
                    staticClass: "fas fa-plus tx-orange plus hover-toggle"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hover-details" }, [
              _c("div", {
                staticClass: "description",
                domProps: {
                  innerHTML: _vm._s(
                    item.acf_fields.feature_settings.post_excerpt
                  )
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "button-container" }, [
                _c(
                  "a",
                  {
                    staticClass: "hover-button orange",
                    attrs: { href: item.permalink }
                  },
                  [_vm._v("Continue reading")]
                )
              ])
            ])
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "emptyList",
        staticClass: "no-items",
        staticStyle: { display: "none" }
      },
      [
        _c("h3", { staticClass: "roboto-mono message" }, [
          _vm._v("No articles found that match this filter.")
        ])
      ]
    ),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", { staticClass: "ajax-spinner" }, [
          _c("i", {
            staticClass: "fas fa-spinner fa-spin float-right tx-dark-gray"
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowLoadMore
      ? _c("div", { staticClass: "load-more-container" }, [
          _c(
            "a",
            {
              staticClass: "btn tx-dark-gray float-right",
              attrs: { href: "javascript:void(0);" },
              on: {
                click: function($event) {
                  return _vm.loadPosts()
                }
              }
            },
            [
              _vm._v("Load more "),
              _c("i", { staticClass: "fas fa-chevron-down" })
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }